import { createActions, createReducer } from 'reduxsauce'

import DespesasPorCredorService from '../../servicos/DespesasPorCredorService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDespesasPorCredorInicio: [],
    buscaDespesasPorCredorSucesso: ['despesasPorCredor'],
    buscaDespesasPorCredorErro: ['erro'],
    setDespesasPorCredorEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataAtualizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaDespesasPorCredor = data => {
    return dispatch => {
        dispatch(Creators.buscaDespesasPorCredorInicio())
        let serv = new DespesasPorCredorService()
        serv.consultar(data)
            .then(response => dispatch(Creators.buscaDespesasPorCredorSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDespesasPorCredorErro(error)))
    }
}

const buscaDespesasPorCredorInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaDespesasPorCredorErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro })

const buscaDespesasPorCredorSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.despesasPorCredor.resultado, dataAtualizacaoDados: action.despesasPorCredor.dataAtualizacaoDados, carregando: false }
}

const setDespesasPorCredorEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DESPESAS_POR_CREDOR_INICIO]: buscaDespesasPorCredorInicio,
    [Types.BUSCA_DESPESAS_POR_CREDOR_ERRO]: buscaDespesasPorCredorErro,
    [Types.BUSCA_DESPESAS_POR_CREDOR_SUCESSO]: buscaDespesasPorCredorSucesso,
    [Types.SET_DESPESAS_POR_CREDOR_ESTADO_DT]: setDespesasPorCredorEstadoDT,
})
